(function () {

  'use strict';

  function pxSelectNetworkAndSnmp($rootScope, SnmpConfigurationService, CopilotService, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        callback: '&'
      },
      templateUrl: 'app/directives/select-network-and-snmp/select-network-and-snmp.template.html',
      link: function (scope) {

        scope.me = $rootScope.currentUser;

        scope.networkSelectorIsOpen = false;
        scope.selectedNetwork = null;
        scope.selectedNetworkIdAsArray = null;

        scope.snmpConfigurationSelectorIsOpen = false;
        scope.selectedSnmpConfiguration = null;

        scope.defaultSnmpConfiguration = null;

        scope.openNetworkSelector = function () {
          scope.networkSelectorIsOpen = true;
        };

        (function fulfillCopilotRequest() {
          if (CopilotService.state.requestedAction.responseType !== 'DISCOVER_PRINTERS') {
            return;
          }
          scope.selectedNetworkName = CopilotService.useDiscoverOnNetworkName();

          if (scope.selectedNetworkName === '') {
            return;
          }

          $timeout(function () {
            scope.networkSelectorIsOpen = true;
          }, 100);
        })();

        scope.onNetworkSelected = function (network) {
          scope.networkSelectorIsOpen = false;
          if (network && (!scope.selectedNetwork || network.customProperties.id !== scope.selectedNetwork.customProperties.id)) {
            scope.selectedNetwork = network;
            scope.selectedNetworkIdAsArray = [network.customProperties.id];
            if (!isSnmpConfigurationValidForNetwork()) {
              scope.selectedSnmpConfiguration = scope.defaultSnmpConfiguration;
            }
            passSelectionToParent();
          }
        };

        scope.openSnmpConfigurationSelector = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.onSnmpConfigurationSelected = function (snmpConfiguration) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfiguration && (!scope.selectedSnmpConfiguration || snmpConfiguration.info._links.self.href !== scope.selectedSnmpConfiguration.info._links.self.href)) {
            scope.selectedSnmpConfiguration = snmpConfiguration;
            passSelectionToParent();
          }
        };

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (snmpConfiguration) {
            scope.defaultSnmpConfiguration = snmpConfiguration;
          }).catch(function(error){});
        }

        function isSnmpConfigurationValidForNetwork() {
          const snmpConfiguration = scope.selectedSnmpConfiguration;
          if (!snmpConfiguration) {
            return false;
          }
          if (snmpConfiguration.info.networkIds && snmpConfiguration.info.networkIds.length) {
            const network = scope.selectedNetwork;
            if (!network || !snmpConfiguration.info.networkIds.includes(network.customProperties.id)) {
              return false;
            }
          }
          return true;
        }

        function passSelectionToParent() {
          scope.callback({
            item: scope.selectedNetwork,
            boolean: scope.selectedNetwork && scope.selectedSnmpConfiguration,
            selectedAttachmentItem: scope.selectedSnmpConfiguration
          });
        }

        (function () {
          getDefaultSnmpConfiguration();
        }());

      }
    };
  }

  pxSelectNetworkAndSnmp.$inject = ['$rootScope', 'SnmpConfigurationService', 'CopilotService', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxSelectNetworkAndSnmp', pxSelectNetworkAndSnmp);

})();
